import { render, staticRenderFns } from "./FirmRoles.vue?vue&type=template&id=9e901bfa&scoped=true"
import script from "./FirmRoles.vue?vue&type=script&lang=js"
export * from "./FirmRoles.vue?vue&type=script&lang=js"
import style0 from "./FirmRoles.vue?vue&type=style&index=0&id=9e901bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e901bfa",
  null
  
)

export default component.exports